function getPersistentPageState(key = '') {
  let name = key != '' ? key : window.location.pathname
  return JSON.parse(localStorage.getItem(name))
}

export default getPersistentPageState
